import React, { useEffect } from 'react';

import { StyledVideo } from './Video.styles';

import { VideoProps } from './Video.types';

const Video = ({
  componentClassname = 'video',
  customClassnames = '',
  customStyle = '',
  videoSlot,
  closeButtonContentSlot,
  isOpen,
  handleClose,
  hasOverlay = true,
}: VideoProps) => {
  useEffect(() => {
    const close = (e: KeyboardEvent) => {
      if (e.key === 'Escape') handleClose();
    };
    window.addEventListener('keyup', close);
    return () => window.removeEventListener('keyup', close);
  }, []);

  if (!isOpen) {
    return null;
  }

  return (
    <StyledVideo
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
    >
      {hasOverlay && (
        <div
          className={`${componentClassname}__overlay`}
          onClick={handleClose}
        />
      )}
      <div className={`${componentClassname}__content`}>
        <div className={`${componentClassname}__content-inner`}>
          {videoSlot}
        </div>
        {closeButtonContentSlot && (
          <button
            className={`${componentClassname}__close-btn`}
            onClick={handleClose}
          >
            {closeButtonContentSlot}
          </button>
        )}
      </div>
    </StyledVideo>
  );
};
Video.displayName = 'Video';

export default Video;
